import type {PredictionInput} from '../newPredictionState';

export interface FileImportSourceRecords {
  count: number;
  label: string;
  skippedCount: number;
}

export interface FileImportSummary {
  importedComponentCount: number;
  importedInputCount: number;
  invalidInputCount: number;
  sourceRecords?: FileImportSourceRecords;
}

export interface FileImportResult {
  inputs: Array<PredictionInput>;
  summary: FileImportSummary;
}

export interface FileImporter {
  acceptedFileTypes: Record<string, Array<string>>;
  importFile: (
    file: File,
    maxInputs: number,
    usedInputNames?: ReadonlySet<string>
  ) => Promise<FileImportResult>;
}

export function normalizeMimeType(mimeType: string): string {
  return mimeType.split(';', 1)[0].trim().toLowerCase();
}

export class FileImportError extends Error {
  readonly title: string;

  constructor(title: string, message: string) {
    super(message);
    this.name = 'FileImportError';
    this.title = title;
  }
}
